import request from "../../../util/SuperagentUtils";

export const getAllPartnerSubscriptions = (account) => {
    const result = request.get(`api/partner-subscription?accountId=${account.id}`);
    return result;
}